var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 449.39 111.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Ads\u0131z_degrade_13);}.cls-1,.cls-2,.cls-3,.cls-4{stroke-width:0px;}.cls-2{fill:url(#Ads\u0131z_degrade_21);}.cls-3{fill:#3a52e6;}.cls-4{fill:#0c49aa;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ads\\u0131z_degrade_13",
    x1: 135.85,
    y1: 119.14,
    x2: 210.18,
    y2: 12.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e53e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e53e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ads\\u0131z_degrade_21",
    x1: 225.58,
    y1: 118.88,
    x2: 137.75,
    y2: -6.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2e53e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#31eeb2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.65,108.67L193.01,9.23l1.75-2.52c.4-.42.9-.89,1.53-1.35.53-.39,1.04-.7,1.49-.94.51-.21,1.12-.42,1.82-.58.74-.17,1.41-.26,1.98-.3,1.17,0,2.34,0,3.52,0l25.22.02c.56,0,1.12,0,1.67,0,.13,0,1,0,1.6.68.52.59.66,1.46.34,2.23-.37.54-.75,1.07-1.12,1.61l-70.72,101.86c-.11.13-.25.28-.43.44-.17.14-.33.26-.47.35-.28.14-.65.28-1.08.36-.33.05-.58.06-.64.05-1.04-.1-31.01-.21-34.06,0-.31.02-.77,0-1.25-.22-.24-.11-.51-.24-.7-.55-.17-.27-.19-.55-.19-.7,0-.12,0-.31.09-.52.08-.23.2-.39.28-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.24,5.23c-.96-1.8-.69-3.8.34-4.66,1.31-1.09,4.22-.67,5.67,1.86,4.19,5.94,7.03,10.37,11.22,16.3l1.35,1.5c.48.41,1.26.59,1.53.58,1.16-.03,2.08-.31,2.92-1.59.11-.17.3-.88.29-1.26-.05-1.95.2-1.91-2.85-5.96-1.9-2.53-2.24-3.13-2.37-3.95-.08-.49-.24-2.22.92-3.12.87-.67,2.09-.63,2.9-.3,1.06.44,1.56,1.14,1.56,1.14l.44.49c.86,1.41,7.19,11.69,9.39,12.03.34.05.7.02.7.02,1.12-.1,2.55-.89,2.96-2.35.37-1.34-.33-2.47-.46-2.66-.62-1.35-1.14-1.73-2.02-3.05-.71-1.05-1.02-2.04-.81-3.14.21-1.12,1.26-1.6,1.26-1.6.74-.41,1.33-.52,2.26-.43,1.22.11,2.11,1.22,2.37,1.6,1.91,2.75,54.06,78.15,68.55,99.09.45.65.86,1.25,1.24,1.79.44.64.97,1.12,1.15,1.67.39,1.13-.85,1.9-1.93,1.91-1.3,0-2.59.02-3.89.03-.33,0-8.57-.15-25.08-.25-2.77-.02-5.76-.03-8.06-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "161.44 54.54 181.1 82.53 179.18 85.32 159.49 57.33 161.44 54.54"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "katman_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.89,111.39H3.08c-2.06,0-3.08-1.03-3.08-3.08V6.16c0-2.06,1.03-3.08,3.08-3.08h40.55c7.71,0,14.48,1.54,20.31,4.62,5.83,3.08,10.33,7.36,13.49,12.83,3.16,5.47,4.74,11.68,4.74,18.62,0,7.4-1.53,13.93-4.59,19.58s-7.45,10.03-13.18,13.14c-5.73,3.11-12.55,4.66-20.47,4.66h-18.96v31.76c0,2.06-1.03,3.08-3.08,3.08ZM49.76,52.03c2.34-1.23,4.16-2.95,5.47-5.16,1.31-2.21,1.97-4.7,1.97-7.48s-.66-5.05-1.97-7.13c-1.31-2.08-3.12-3.7-5.43-4.86s-4.91-1.73-7.79-1.73h-17.04v28.21h16.96c2.88,0,5.48-.62,7.82-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.39,111.39h-18.81c-2.06,0-3.08-1.03-3.08-3.08V6.16c0-2.06,1.03-3.08,3.08-3.08h18.81c2.05,0,3.08,1.03,3.08,3.08v102.14c0,2.06-1.03,3.08-3.08,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M345.86,109.15c0,.72-.23,1.27-.69,1.66s-1.11.58-1.93.58h-19.35c-1.75,0-2.9-.85-3.47-2.54l-5.7-15.88h-41.39l-5.63,15.88c-.51,1.7-1.67,2.54-3.47,2.54h-19.35c-.82,0-1.48-.19-1.97-.58s-.73-.94-.73-1.66c0-.41.08-.85.23-1.31L282.19,5.39c.62-1.64,1.8-2.47,3.55-2.47h16.73c1.8,0,3.01.82,3.62,2.47l39.55,102.45c.15.46.23.9.23,1.31ZM307.55,71.92l-12.33-34.77-1.23-4.39-1.08,4.39-12.33,34.77h26.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M352.41,108.3V6.16c0-2.06,1.03-3.08,3.08-3.08h37c10.43,0,19.99,2.36,28.68,7.09,8.68,4.73,15.56,11.23,20.62,19.5,5.06,8.27,7.59,17.45,7.59,27.52s-2.52,19.25-7.55,27.52c-5.04,8.27-11.88,14.79-20.54,19.54-8.66,4.75-18.18,7.13-28.56,7.13h-37.23c-2.06,0-3.08-1.03-3.08-3.08ZM409.15,83.56c4.62-2.57,8.26-6.14,10.91-10.71,2.65-4.57,3.97-9.79,3.97-15.65s-1.32-10.93-3.97-15.53c-2.65-4.6-6.3-8.18-10.95-10.75-4.65-2.57-9.88-3.85-15.69-3.85h-16.03v60.36h16.19c5.75,0,10.95-1.28,15.57-3.85Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3eb6df50a4392025e4314098d9f5a09c.svg";
export { ForwardRef as ReactComponent };